import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  extend
} from '@thd-nucleus/data-sources';
import { DrawerBody, DrawerFooter, Button } from '@one-thd/sui-atomic-components';
import { Specifications } from '@thd-olt-component-react/specifications';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';
import { useIntentProductData } from '../../hooks/useIntentProductData';

export const ProductSpecs = ({
  itemId, isDisplayOnly, onSubmit
}) => {
  const { addToType } = useContext(AddToContext);
  const { MINI_PIP_PRODUCT_SPECS } = SCREENS;

  const handleSubmit = async () => {
    onSubmit(MINI_PIP_PRODUCT_SPECS);
  };

  return (
    <>
      <DrawerBody data-testid="test-productspecs">
        <Specifications itemId={itemId} hideMobileFade oneColumn />
      </DrawerBody>
      <DrawerFooter position="center">
        {!isDisplayOnly && (
          <Button
            data-testid="productSpecs-AITP-button"
            variant="secondary"
            fullWidth
            onClick={handleSubmit}
            type="submit"
          >
            Add to {addToType}
          </Button>
        )}
      </DrawerFooter>
    </>
  );
};

ProductSpecs.displayName = 'ProductSpecs';

ProductSpecs.propTypes = {
  itemId: PropTypes.string.isRequired,
  isDisplayOnly: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

ProductSpecs.defaultProps = {
  isDisplayOnly: false
};

ProductSpecs.dataModel = extend(Specifications, useIntentProductData);
